var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.075 8.2658C9.815 8.09247 9.165 7.91913 8.66667 8.54747C8.14667 9.1758 7.51833 10.2158 5.15667 7.85413C2.77333 5.4708 3.835 4.84247 4.46333 4.34413C5.09167 3.82413 4.91833 3.1958 4.745 2.9358C4.55 2.65413 3.445 0.942465 3.25 0.660799C3.055 0.379132 2.795 -0.0758681 2.18833 0.0107986C1.73333 0.0757986 0 0.985799 0 2.9358C0 4.8858 1.53833 7.26913 3.64 9.3708C5.72 11.4508 8.125 12.9891 10.0533 12.9891C11.9817 12.9891 12.9133 11.2558 12.9783 10.8225C13.065 10.2158 12.61 9.9558 12.3283 9.7608C12.0467 9.54413 10.335 8.43913 10.075 8.2658Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.503aa204b8744ae6e9d675edd5ab98ba.svg";
export { ForwardRef as ReactComponent };